import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  template: `
    <footer
      class="w-full bg-gray-100 flex flex-col gap-2 justify-center items-center pt-6 pb-2 border-t-[1px] border-gray-200"
    >
      <p class="text-sm text-center">
        &copy; Mi Cable GO es un marca registrada a nombre de<br />
        TELEVISION PUNTO I COMUNICACIONES S.R.L
      </p>

      <div class="flex justify-center items-center gap-4">
        <a
          href="https://www.facebook.com/micablerd"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/facebook_ico.png" alt="Logo" class="h-10" />
        </a>
        <a
          href="https://www.instagram.com/micablerd/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/instagram_ico.png" alt="Logo" class="h-10" />
        </a>
      </div>

      <div class="flex  flex-col justify-center items-center">
        <p class="text-sm text-center">Powered by</p>
        <a
          href="https://automate.do"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/automate.png" alt="Logo" class="h-10" />
        </a>
        <span class="text-[0.6rem] text-gray-400 mt-1">v1.8.0</span>
      </div>
    </footer>
  `,
})
export class FooterComponent {}
